import { SellerFilter, MarketplaceFilter, CategoryFilter } from "@/components/new-filters";
import { mapState } from 'vuex';
import FiltersFrame from "@/components/new-filters/FiltersFrame.vue";
import { EVENTS } from "@/utils";
export default {
  name: "MarketInsightsFilters",
  components: {
    SellerFilter,
    MarketplaceFilter,
    FiltersFrame,
    CategoryFilter
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.customer_insights.sellers_filter,
      marketplaces_filter: state => state.customer_insights.marketplaces_filter
    })
  },
  methods: {
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for sellers...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_CUSTOMER_INSIGHTS_SELLERS_SUB_FILTERS, false);
        window.$bus.trigger(EVENTS.REFRESH_CUSTOMER_INSIGHTS);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        await window.$bus.trigger(EVENTS.REFRESH_CUSTOMER_INSIGHTS_MARKETPLACES_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_CUSTOMER_INSIGHTS);
      }
    }
  }
};